import {
  DataSource,
  Target,
  YearType,
} from '../../Utils';
import {
  GraphSubject,
} from '../../viz/Utils';
import {
  getDataStatusSelector as getCCPY_CC_Selector,
} from '../fetchedData/countryCountryProductYearByCountryCountry';
import {
  getDataStatusSelector as getCCPY_CP_Selector,
} from '../fetchedData/countryCountryProductYearByCountryProduct';
import {
  getDataStatusSelector as getCCY_C_Selector,
} from '../fetchedData/countryCountryYearByCountry';
import {
  getDataSelector as getCountryLevelSelector,
} from '../fetchedData/countryLevelMapping';
/* Location aggregation groups-related fetches */
import {
  getDataSelector as getGroupsMetadataSelector
} from '../../sharedData/groupsMetadata';
import {
  getDataSelector as getGroupMembersMetadataSelector
} from '../../sharedData/groupMembersMetadata';


import {
  getDataSelector as getCountryMetadataSelector,
} from '../fetchedData/countryMetadata';
import {
  getDataStatusSelector as getCPY_C_Selector,
} from '../fetchedData/countryProductYearByCountry';
import {
  getDataStatusSelector as getCPY_P_Selector,
} from '../fetchedData/countryProductYearByProduct';
import {
  getDataStatusSelector as get_CY_Selector,
} from '../fetchedData/countryYear';
import {
  getDataSelector as getProductLevelSelector,
  MappingType,
} from '../fetchedData/productLevelMapping';
import {
  getDataSelector as getProductMetadataSelector,
} from '../fetchedData/productMetadata';
import {
  getDataStatusSelector as get_PY_Selector,
} from '../fetchedData/productYear';
import {
  IRegistryEntry,
} from '../getWorkerEnhancer';
import {
  IWorkerRootState,
} from '../workerRootState';
import createDeflatorsLookupTable from './createDeflatorsLookupTable';
import createPopulationLookupTable from './createPopulationLookupTable';
import {
  checkForInvalidRoutingInput,
  IInputFromURLRouting,
  ISuccessfulMergeAction,
  IUIState,
  START_SUBSCRIBING,
  STOP_SUBSCRIBING,
} from './getReducer';
import merge, {
  IMergeInput,
} from './merge';
import {
  getInputFromURLRouting,
  getUIState,
  hasMergeAlreadyBeenComputed,
} from './reducer';

type IRelevantStorePart = {
  countryCountryProductYearByCountryCountry: IWorkerRootState['countryCountryProductYearByCountryCountry'];
  countryCountryProductYearByCountryProduct: IWorkerRootState['countryCountryProductYearByCountryProduct'];
  countryCountryYearByCountry: IWorkerRootState['countryCountryYearByCountry'];
  countryLevelMapping: IWorkerRootState['countryLevelMapping'];
  countryProductYearByCountry: IWorkerRootState['countryProductYearByCountry'];
  countryProductYearByProduct: IWorkerRootState['countryProductYearByProduct'];
  countryMetadata: IWorkerRootState['countryMetadata'];
  productMetadata: IWorkerRootState['productMetadata'];
  productLevelMapping: IWorkerRootState['productLevelMapping'];
  productYear: IWorkerRootState['productYear'];
  countryYear: IWorkerRootState['countryYear'];
  yearly: IWorkerRootState['yearly'];
} & IWorkerRootState['stack']['uiState'] & IInputFromURLRouting;

const getRelevantSubStore = (rootState: IWorkerRootState) => {
  const {
    countryProductYearByCountry, countryProductYearByProduct,
    countryCountryYearByCountry,
    countryCountryProductYearByCountryCountry, countryCountryProductYearByCountryProduct,
    countryLevelMapping, productLevelMapping, productMetadata, countryMetadata,
    productYear, countryYear, yearly, groupsMetadata, groupMembersMetadata,
    stack: {uiState},
  } = rootState;
  const relevantPart: IRelevantStorePart = {
    countryProductYearByCountry, countryProductYearByProduct,
    countryCountryYearByCountry,
    countryCountryProductYearByCountryCountry, countryCountryProductYearByCountryProduct,
    countryLevelMapping, productLevelMapping, productMetadata, countryMetadata,
    productYear, countryYear, yearly, groupsMetadata, groupMembersMetadata,
    ...uiState,
    ...getInputFromURLRouting(rootState),
  };
  return relevantPart;
};

/* Start of getComputationInput */

const getData_CPY_C = getCPY_C_Selector();
const getData_CPY_P = getCPY_P_Selector();
const getData_CCPY_CP = getCCPY_CP_Selector();
const getData_CCPY_CC = getCCPY_CC_Selector();
const getData_CCY_C = getCCY_C_Selector();
const getProductLevelMapping = getProductLevelSelector();
const getCountryLevelMapping = getCountryLevelSelector();
const getProductMetadata = getProductMetadataSelector();
const getCountryMetadata = getCountryMetadataSelector();
const getData_PY = get_PY_Selector();
const getData_CY = get_CY_Selector();

const getGroupsMetadata = getGroupsMetadataSelector();
const getGroupMembersMetadata = getGroupMembersMetadataSelector();


const getMergeInput = (rootState: IWorkerRootState): IMergeInput => {
  const retrieved = getInputFromURLRouting(rootState);
  const {
    productClass, tradeDirection, tradeFlow, country, queryLevel, target, product, partner,
    startYear, endYear,
  } = retrieved;
  const {
    productLevel, deselectedCategories,
    countryLevel, populationAdjustment, inflationAdjustment, layout, ordering,
    svgWidth, svgHeight,
  } = getUIState(rootState);
  const yearRequest = {
    type: YearType.All as YearType.All,
  };


  const populationData = getData_CY(rootState, {year: yearRequest});
  const deflatorsData = getData_PY(rootState, {productClass, year: yearRequest});


  let result: IMergeInput;
  if (target === Target.Product) {
    if (country !== undefined && product === undefined) {
      const payload = {
        productClass, country, queryLevel, year: yearRequest,
        level: productLevel,
      };
      const productMetadata = getProductMetadata(rootState, payload);
      const high2LowMapping = getProductLevelMapping(rootState, {productClass, mappingType: MappingType.Hi2Low});
      const high2MidMapping = getProductLevelMapping(rootState, {productClass, mappingType: MappingType.Hi2Mid});
      const groupsMetadata = getGroupsMetadata(rootState, {});
      const groupMembersMetadata = getGroupMembersMetadata(rootState, {});
      result = {
        source: DataSource.CPY,
        subject: GraphSubject.Product,
        mainData: getData_CPY_C(rootState, payload),
        metadata: productMetadata,
        high2LowMapping,
        high2MidMapping,
        deflatorsData: createDeflatorsLookupTable(deflatorsData),
        populationData: createPopulationLookupTable(populationData, groupsMetadata, groupMembersMetadata),
        level: productLevel,
        productClass, tradeDirection, tradeFlow, deselectedCategories,
        svgWidth, svgHeight, ordering, layout,
        populationAdjustment, inflationAdjustment,
        startYear, endYear,
        country, queryLevel
      };
    } else if (country === undefined && product !== undefined) {
      const payload = {
        productClass, product, year: yearRequest,
      };
      const countryMetadata = getCountryMetadata(rootState, payload);
      const levelMapping = getCountryLevelMapping(rootState, {});
      const groupsMetadata = getGroupsMetadata(rootState, {});
      const groupMembersMetadata = getGroupMembersMetadata(rootState, {});
      result = {
        subject: GraphSubject.Country,
        source: DataSource.CPY,

        mainData: getData_CPY_P(rootState, payload),
        metadata: countryMetadata,
        levelMapping,
        deflatorsData: createDeflatorsLookupTable(deflatorsData),
        groupsMetadata,
        groupMembersMetadata,
        productClass, tradeDirection, tradeFlow,
        deselectedCategories, svgWidth, svgHeight, ordering,
        inflationAdjustment, layout, startYear, endYear,
        level: countryLevel,
      };
    } else if (country !== undefined && product !== undefined) {
      const payload = {
        productClass, country, queryLevel, product, year: yearRequest,
      };
      const levelMapping = getCountryLevelMapping(rootState, {});
      const countryMetadata = getCountryMetadata(rootState, payload);
      const groupsMetadata = getGroupsMetadata(rootState, {});
      const groupMembersMetadata = getGroupMembersMetadata(rootState, {});
      result = {
        subject: GraphSubject.Country,
        source: DataSource.CCPY,

        mainData: getData_CCPY_CP(rootState, payload),
        metadata: countryMetadata,
        levelMapping,
        deflatorsData: createDeflatorsLookupTable(deflatorsData),
        groupsMetadata,
        groupMembersMetadata,
        productClass, tradeDirection, tradeFlow,
        deselectedCategories, svgWidth, svgHeight, ordering,
        populationAdjustment, inflationAdjustment, layout, startYear, endYear,
        level: countryLevel
      };
    } else {
      throw new Error('This code path should not happen');
    }
  } else {
    if (country !== undefined && partner !== undefined) {
      const payload = {
        productClass, country, queryLevel, partner, year: yearRequest,
        level: productLevel,
      };
      const productMetadata = getProductMetadata(rootState, payload);
      const high2LowMapping = getProductLevelMapping(rootState, {productClass, mappingType: MappingType.Hi2Low});
      const high2MidMapping = getProductLevelMapping(rootState, {productClass, mappingType: MappingType.Hi2Mid});
      const groupsMetadata = getGroupsMetadata(rootState, {});
      const groupMembersMetadata = getGroupMembersMetadata(rootState, {});

      result = {
        source: DataSource.CCPY,
        subject: GraphSubject.Product,
        mainData: getData_CCPY_CC(rootState, payload),
        metadata: productMetadata,
        high2LowMapping,
        high2MidMapping,
        groupsMetadata,
        groupMembersMetadata,
        deflatorsData: createDeflatorsLookupTable(deflatorsData),
        populationData: createPopulationLookupTable(populationData, groupsMetadata, groupMembersMetadata),
        level: productLevel,
        productClass, tradeDirection, tradeFlow, deselectedCategories,
        svgWidth, svgHeight, ordering, layout,
        populationAdjustment, inflationAdjustment,
        startYear, endYear,
        country, partner, queryLevel
      };
    } else if (country !== undefined && partner === undefined) {
      const payload = {
        country, queryLevel, year: yearRequest,
      };
      const levelMapping = getCountryLevelMapping(rootState, {});
      const countryMetadata = getCountryMetadata(rootState, payload);
      const groupsMetadata = getGroupsMetadata(rootState, {});
      const groupMembersMetadata = getGroupMembersMetadata(rootState, {});
      result = {
        subject: GraphSubject.Country,
        source: DataSource.CCY,

        mainData: getData_CCY_C(rootState, payload),
        metadata: countryMetadata,
        levelMapping,
        groupsMetadata,
        groupMembersMetadata,
        deflatorsData: createDeflatorsLookupTable(deflatorsData),

        productClass, tradeDirection, tradeFlow,
        deselectedCategories, svgWidth, svgHeight, ordering,
        populationAdjustment, inflationAdjustment, layout, startYear, endYear,
        level: countryLevel,
      };
    } else {
      throw new Error('This code path should not happen');
    }
  }
  return result;
};


/* End of getComputationInput */

const isURLRoutingInputValidForUI = (input: IInputFromURLRouting) => checkForInvalidRoutingInput(input).isValid;

const productSpaceRegistry: IRegistryEntry<
  IWorkerRootState,

  typeof START_SUBSCRIBING,
  typeof STOP_SUBSCRIBING,

  IInputFromURLRouting,
  IUIState,

  IRelevantStorePart,
  IMergeInput,
  ISuccessfulMergeAction
> = {
  startListeningActionName: START_SUBSCRIBING,
  stopListeningActionName: STOP_SUBSCRIBING,
  getRelevantSubStore,
  getComputationInput: getMergeInput,
  isURLRoutingInputValidForUI,
  getURLRoutingInputFromRootState: getInputFromURLRouting,
  getUIStateFromRootState: getUIState,
  compute: merge,
  hasMergeAlreadyBeenComputed,
};

export default productSpaceRegistry;
